export default __webpack_public_path__ + "static/media/avatar.da7227eb.jpg";